<template>
  <div>
    <admin-form-item label="슈퍼바이저">
      <div v-if="$store.getters.mode==='supervisor'">
        {{ $store.getters.supervisor.name }}
      </div>
      <div v-else>
        <toggle-button @change="enableSuperVisor"
                       :value="is_super_visor"
                       :sync="true"
                       class="changed-font"
                       :width="100"
                       :height="24"
                       :labels="{'checked':'활성화', 'unchecked':'비활성화'}"></toggle-button>
        <lp-adm-drop-input :data.sync="super_visor_list"
                           :selectVal="superVisorName"
                           @onSelect="selectSuperVisor"
                           placeholder="검색 후 선택"
                           listAlign="left"
                           width="250px"
                           style="margin-top:12px;"
                           v-if="is_super_visor"></lp-adm-drop-input>
      </div>
    </admin-form-item>
    <admin-form-item label="파트너* (복수 추가 가능)" v-if="prod.is_super_visor">
      <lp-multiple-drop-input :data.sync="partner_list"
                              @onSelect="selectPartnerList"
                              placeholder="팀 선택"
                              width="240px"
                              listAlign="center"
                              style="display:inline-block; margin-right:4px;"></lp-multiple-drop-input>
      <!--   선택된 파트너 태그들   -->
      <div class="flex wrap partner-tag-wrapper" v-if="isSelectedPartners">
        <div v-for="(partner, p_idx) in partner_list" :key="`partner-${p_idx}`">
          <div style="margin-right:12px;" class="flex-align" v-if="partner.selected">
            <span class="partner-name">{{ partner.name }}</span>
            <i class="material-icons partner-close-icon unselect" @click="removePartner(partner)">close</i>
          </div>
        </div>
      </div>
    </admin-form-item>
  </div>
</template>

<script>
  import LpMultipleDropInput from "../../../module/common/LpMultipleDropInput";
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";

  export default {
    name: "PanelSuperVisor",
    components: {LpAdmDropInput, LpMultipleDropInput},
    props: {
      prod: {
        type: Object
      }
    },
    data() {
      return {
        super_visor_list: [],
        partner_list: [],
        is_super_visor: false
      }
    },
    created() {
      this.is_super_visor = this.prod.is_super_visor;

      if (this.$store.getters.mode === 'supervisor') {
        this.prod.super_visor_id = this.$store.getters.supervisor.id;
        this.is_super_visor = true;
        this.prod.is_super_visor = true;
      } else if (this.prod.super_visor_id) {
        //this.is_super_visor = true;
      }
      if(this.isAdmin) {
        this.getSuperVisorSimpleList();
      }
      this.getSuperVisorSimplePartnerList();
    },
    computed: {
      superVisorName() {
        let item = find(this.super_visor_list, 'value', this.prod.super_visor_id);
        if (item) return item.name;
        else return '';
      },
      isSelectedPartners() {
        return this.partner_list.some(item => {
          return item.selected;
        });
      }
    },
    methods: {
      enableSuperVisor (e) {
        this.is_super_visor = e.value;
        this.$emit('IsSuperVisor', e.value);
        if(!e.value) {
          this.prod.super_visor_id = '';
          this.prod.partner_list = [];
          this.partner_list.forEach(item => {
            item.selected = false;
          })
        }
      },
      removePartner (partner) {
        partner.selected=!partner.selected;
        let partner_list = [];
        this.partner_list.forEach(item => {
          if(item.selected) {
            partner_list.push(item.value);
          }
        })
        this.prod.partner_list = partner_list;
      },
      selectPartnerList (res) {
        this.prod.partner_list = res;
      },
      selectSuperVisor(res) {
        this.prod.super_visor_id = res.value;
        this.getSuperVisorSimplePartnerList();
      },
      getSuperVisorSimpleList() {
        let url = `supervisor/simple`
        this.$axios.get(this.getUrl(url)).then(res => {
          if (res.status === 200) {
            this.super_visor_list = res.data;
          }
        })
      },
      getSuperVisorSimplePartnerList() {
        if (!this.prod.super_visor_id) {
          return
        }
        let url = `supervisor/${this.prod.super_visor_id}/partner/simple`
        this.$axios.get(this.getUrl(url)).then(res => {
          if (res.status === 200) {
            let partners = [];
            res.data.forEach(item => {
              let data = this.cloneItem(item);
              data.selected = false;
              partners.push(data);
            })
            this.partner_list = partners;

            if(this.$route.query.id>0)  {
              if(this.prod.partner_list.length>0) {
                this.prod.partner_list.forEach(id => {
                  let item = find(this.partner_list, 'value', id);
                  if(item) {
                    item.selected = true;
                  }
                })
              }
            }
          }
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
  .partner-name
    color $primary
    margin-right 4px

  .partner-close-icon
    color white
    background-color $primary
    font-size 13px
    border-radius 13px

  .partner-tag-wrapper
    border 1px solid #dbdbdb
    border-radius 3px
    padding 8px
    margin-top 12px
    margin-bottom 12px
    height 97px
    overflow-y scroll
</style>
